/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import img from '../../assets/img/alphaversion.png';

const AlphaVersion: React.FC = () => <img src={img} alt='Alpha version' className='alphaVersion' />;
export default AlphaVersion;
